module.exports = __webpack_public_path__ + "static/media/luv-homes-logo.e6ef67e8.svg";